<template>
  <div class="aftersale-detail">
    <!--    权限按钮-->
    <!--    发货 delivery-->
    <!--    更新物流  updateLogis-->
    <!--    物流记录  logisRecord-->
    <!--    保存   save-->
    <!--    修改物流   editLogis-->
    <!--    新增物流   addLogis-->
    <!--    删除物流   deleteLogis-->

    <!--    isDelivery: false,-->
    <!--    isUPdate:false,-->
    <!--    isShowRcode:false,-->
    <!--    isShowSave:false,-->
    <div class="">
      <el-page-header @back="goBack" content="详情页面"></el-page-header>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{ detailData.afterSaleName }}</li>
          <li class="mgb15">手机号码：{{ detailData.afterSaleMobile }}</li>
          <li class="mgb15">商品名称：{{ orderDetail.orderItems && orderDetail.orderItems[0] &&
              orderDetail.orderItems[0].productSkuName
          }}
          </li>
          <li class="mgb15">子订单号：{{ detailData.orderNo }}</li>
          <li>下单时间：{{ detailData.creationTime }}</li>
          <!-- <li>换货地址：姓名/手机号/详细地址</li> -->
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>换货人信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">
            <span>换货人姓名：{{ detailData.afterSaleName }}</span>
          </li>
          <li class="mgb15"><span>换货人电话：{{ detailData.afterSaleMobile }}</span></li>
          <!--          <li class="mgb15">换货地址：</li>-->
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申请信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">售后类型：换货</li>
          <!--          <li class="mgb15">购买数量：17828282822</li>-->
          <!--          <li class="mgb15">实付金额：谢谢谢谢谢谢</li>-->
          <!-- 退款 -->
          <li class="mgb15">
            <!--            <span class="mgr40">申请退款数量：22</span>-->
            <!--            <span class="mgr40">申请退款金额：￥22</span>-->
            <!--            <span>退款状态：￥22</span>-->
          </li>
          <!-- 退货 -->
          <li class="mgb15">
            <span class="mgr40">申请换货数量：{{ detailData.afterSaleQuantity }}</span>
            <span class="mgr40">申请换货金额：￥{{ detailData.afterSaleAmount }}</span>
            <!--            <span>退款状态：</span>-->
          </li>
        </ul>
      </div>
    </el-card>
    <el-card>
      <!-- 退货 -->
      <div>
        <el-table :data="tableData" border>
          <div slot="header" class="clearfix">
            <span>售后信息</span>
          </div>
          <el-table-column prop="orderAfterSaleNo" label="售后单号" align="center"></el-table-column>
          <el-table-column prop="supllierName" label="供应商名称" align="center"></el-table-column>
          <el-table-column prop="afterSaleQuantity" label="所需换货数量" align="center"></el-table-column>
          <el-table-column prop="afterSaleAmount" label="所需换货金额" align="center"></el-table-column>
          <el-table-column label="退回状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.isReturn ? '已退回' : '未退回' }}
            </template>
          </el-table-column>
          <el-table-column label="确认退回" align="center">
            <template slot-scope="scope">
              <el-button v-if="isShowBack && !scope.row.isReturn" @click="back(scope.row)" type="primary" size="mini">
                确认退回</el-button>
              <span v-else>无需操作</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-card style="width: 350px;margin-top: 15px;" v-for="(item, index) in exchangeLogisInfo">
          <div style="padding:10px;">换货物流信息</div>
          <div style="padding:10px;">采购供应商：{{ item.supllierName }}</div>
          <div style="padding:10px;">换货数量：{{ item.afterSaleQuantity }}</div>
          <div style="padding-top:20px;">
            <el-button @click="delivery(item, index)" size="mini" type="primary">发货
              <!--            <el-button v-if="!item.isReturn" @click="delivery(item, index)" size="mini" type="primary">发货-->
            </el-button>
            <el-button @click="updateLogistics(item)" size="mini" type="primary">更新物流</el-button>
            <el-button @click="logisRecord1(item)" size="mini" type="primary">物流记录</el-button>
          </div>
        </el-card>
      </div>
      <div style="padding-top:10px;">
        <div style="margin-bottom:10px;">备注</div>
        <p></p>
        <el-input :autosize="{ minRows: 2 }" style="width:500px;" v-model="remark" type="textarea"></el-input>
      </div>
      <div class="btn-box">
        <el-button v-if="isShowSave" type="primary" @click="save">确认</el-button>
      </div>
    </el-card>
    <el-dialog title="发货" :visible.sync="deliveryDialog" :show-close="false" :close-on-click-modal="false" width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <!--        <el-form-item label="采购供应商">-->
        <!--          <el-input v-model="form.productSupplierName" :disabled="true"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="物流公司：">-->
        <!--          <el-autocomplete-->
        <!--              v-model="form.logisticsCompanyName"-->
        <!--              :fetch-suggestions="querySearchAsync"-->
        <!--              placeholder="请选择物流公司 可搜索"-->
        <!--              @select="handleSelect"-->
        <!--          ></el-autocomplete>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="物流单号">-->
        <!--          <el-input-->
        <!--              v-model="form.logisticsNo"-->
        <!--          >-->
        <!--          </el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="需发货数量">
          <el-input v-model="form.afterSaleQuantity" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="已发货数量">
          <el-input v-model="form.shipmentQuantity" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="剩余发货数量">
          <el-input v-model="form.remainQuantity" :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="选择发货数量">
          <el-input-number v-model="form.currentShipmentQuantity" :min="1" :max="1000" label="描述文字"></el-input-number>
          <!--          <el-input-->
          <!--              v-model="form.currentShipmentQuantity"-->
          <!--              :disabled="true">-->
          <!--          </el-input>-->
        </el-form-item>
        <el-form-item label="选择发货仓库">
          <el-button type="primary" size="small" @click="getWarehouseInfos">请选择仓库</el-button>
          <!--          <el-select @change="getWarehouseInfo" v-model="form.warehouseName" placeholder="仓库选择">-->
          <!--            <el-option-->
          <!--                v-for="item in wareHouseData"-->
          <!--                :key="item.warehouseId"-->
          <!--                :label="item.warehouseName"-->
          <!--                :value="item">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <el-form-item v-if="isShowChooseData" label="已选择仓库:">
          &nbsp; &nbsp; 仓库名称: {{ currentWarehouseData.warehouseName }}, &nbsp; &nbsp;
          可用库存：{{ currentWarehouseData.stock }} &nbsp; &nbsp;
          是否符合: {{ currentWarehouseData.isAccord ? '符合' : '不符合' }}
        </el-form-item>
      </el-form>
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchCreateCancel">取 消</el-button>
        <el-button type="primary" @click="batchCreate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流更新" :visible.sync="updateLoggisDialog" :show-close="false" :close-on-click-modal="false"
      width="80%">
      <el-table :data="updateLogisData" border style="width: 100%">
        <!--        <el-table-column-->
        <!--            prop="warehouseName"-->
        <!--            align="center"-->
        <!--            label="id"-->
        <!--            width="80">-->
        <!--        </el-table-column>-->
        <el-table-column prop="warehouseName" align="center" label="发货仓库">
        </el-table-column>
        <el-table-column align="center" prop="shipmentQuantity" label="发货数量">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop=""-->
        <!--            label="物流公司">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop=""-->
        <!--            label="物流单号">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            prop="address"-->
        <!--            align="center"-->
        <!--            label="此单发货数量">-->
        <!--        </el-table-column>-->
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="createLogis(scope.row)" v-if="isUpateLogisShow" size="mini">新增
            </el-button>
            <!--            <el-button @click="editingLogis(scope.row)" v-if="isUpateLogisShow" size="mini">修改</el-button>-->
            <!--            <el-button @click="deleteLogis(scope.row)" v-if="isDelLogisShow" size="mini">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <!--      <el-form label-width="100px">-->
      <!--        <el-form-item label="物流公司：">-->
      <!--          <el-autocomplete-->
      <!--              v-model="updateLogis.logisticsCompanyName"-->
      <!--              :fetch-suggestions="querySearchAsync"-->
      <!--              placeholder="请选择物流公司 可搜索"-->
      <!--              @select="handleSelect"-->
      <!--          ></el-autocomplete>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="物流单号">-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticsNo"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->

      <!--        </el-form-item>-->
      <!--        <el-form-item label='此单发货数量'>-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticQuantity"-->
      <!--                placeholder="请输入发货数量"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateLogisCancel">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="updateLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增物流" :visible.sync="createLoggisDialog" :show-close="false" :close-on-click-modal="false"
      width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <el-form-item label="物流公司：">
          <el-autocomplete style="width:300px;" v-model="addLogis.logisticsCompanyName"
            :fetch-suggestions="querySearchAsync" placeholder="请选择物流公司 可搜索" @select="handleSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input style="width:300px;" v-model="addLogis.logisticsNo">
          </el-input>
        </el-form-item>
        <el-form-item label='此单发货数量'>
          <el-input style="width:300px;" v-model="addLogis.logisticQuantity">
          </el-input>
        </el-form-item>
      </el-form>
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="createLogisCancel">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="createLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改物流" :visible.sync="editLoggisDialog" :show-close="false" :close-on-click-modal="false"
      width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <el-form-item label="物流公司：">
          <el-autocomplete v-model="editLogis.logisticsCompanyName" :fetch-suggestions="querySearchAsync"
            placeholder="请选择物流公司 可搜索" @select="handleSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="editLogis.logisticsNo">
          </el-input>
        </el-form-item>
        <el-form-item label='此单发货数量'>
          <el-input v-model="editLogis.logisticQuantity" placeholder="8">
          </el-input>
        </el-form-item>
      </el-form>
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editLogisCancel">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="editLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流记录" :visible.sync="showRecordDialog" :show-close="false" :close-on-click-modal="false"
      width="80%">

      <el-table :data="recordData" border style="width: 100%">
        <el-table-column prop="id" align="center" label="id">
        </el-table-column>
        <el-table-column prop="logisticsCompanyName" align="center" label="物流公司名称">
        </el-table-column>
        <el-table-column prop="logisticsCompanyCode" align="center" label="物流公司编码">
        </el-table-column>
        <el-table-column prop="logisticsNo" align="center" label="物流单号">
        </el-table-column>
        <el-table-column align="center" prop="logisticQuantity" label="总发货数量">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsCompanyName"-->
        <!--            label="物流公司">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsNo"-->
        <!--            label="物流单号">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            prop="shipmentQuantity"-->
        <!--            align="center"-->
        <!--            label="此单发货数量">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            width="250"-->
        <!--            align="center"-->
        <!--            label="操作">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button @click="createLogis(scope.row)" v-if="isUpateLogisShow" size="mini">新增</el-button>-->
        <!--            <el-button @click="editingLogis(scope.row)" v-if="isUpateLogisShow" size="mini">修改</el-button>-->
        <!--            <el-button @click="deleteLogis(scope.row)" v-if="isDelLogisShow" size="mini">删除</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRecordDialog = false;">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="showRecordDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择发货仓库" :visible.sync="chooseDialog" :show-close="false" :close-on-click-modal="false"
      width="60%">

      <el-table :data="logisData" border highlight-current-row @current-change="handleCurrentChange"
        style="width: 100%">
        <el-table-column prop="warehouseId" align="center" label="id" width="80">
        </el-table-column>
        <el-table-column prop="warehouseName" align="center" label="仓库名称" width="80">
        </el-table-column>
        <el-table-column align="center" label="是否符合">
          <template slot-scope="scope">
            {{ scope.row.isAccord ? '符合' : '不符合' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="stock" label="可用库存">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose">取 消</el-button>
        <el-button :loading="buttonLoading" type="primary" @click="confirmChoose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  BatchCreate, LogisticsCompanyServiceGetAll,
  OrderAfterSaleGet,
  OrderAfterSaleGetAll,
  OrderAfterSaleUpdate,
  GetAllInventoryItems, // 仓库列表
  GetAllInventoryItemsWithOrder, // 根据订单查询仓库信息
  OrderAfterSaleLogisticGetAll,  // 更新物流 仓库查询
  OrderAfterSaleLogisticCreate,
  OrderAfterSaleLogisticUpdate,
  OrderAfterSaleLogisticDelete,
  OrderAfterSaleReject,
  OrderAfterSaleLogisticGet,
  ConfirmReturn,
  OrderAfterSaleWarehouseGetAll, // 查询已发货数量 根据售后单id
  OrderAfterSaleWarehouseCreate, OrderPurchaseGet,  // 仓库发货
} from '../../../api/api'
import { getButtonList } from "../../../promissionRouter";

export default {
  data() {
    return {
      currentOrderAfterSaleDetailId: null,
      chooseDialog: false,
      isEditLogisShow: false,
      isUpateLogisShow: false,
      isDelLogisShow: false,
      buttonLoading: false,
      deliveryDialog: false,
      isDelivery: false,  // 发货
      isUPdate: false, //更新物流
      isShowRcode: false,// 物流记录
      isShowSave: false,// 保存
      isShowBack: false,// 退回
      buttonList_toolBar: [],
      buttonList_table: [],
      id: null,
      detailData: {},
      tableData: [],
      remark: '',
      form: {
        orderAfterSaleId: '',
        orderAfterSaleDetailId: '',
        currentShipmentQuantity: null,
        remainQuantity: null,
        shipmentQuantity: null,
        afterSaleQuantity: null,
        warehouseId: null,
        warehouseName: '',
      },
      wareHouseData: [],
      logisDialog: false,
      logisData: [],
      recordData: [],
      record: [],
      recordDialog: false,
      createLoggisDialog: false,
      editLoggisDialog: false,
      showRecordDialog: false,
      deliveryInfo: [],
      currentWarehouseData: {
        warehouseName: '',
        stock: '',
        isAccord: '',
        warehouseId: null
      },
      isShowChooseData: false,
      updateLogis: {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsNo: '',
        logisticQuantity: null,
      },
      addLogis: {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        logisticsNo: '',
        logisticQuantity: null,
        orderAfterSaleWarehouseId: null,
      },
      editLogis: {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsNo: '',
        logisticQuantity: null,
      },
      updateLoggisDialog: false,
      exchangeLogisInfo: [],
      updateLogisData: [], //更新物流数据
      orderDetail: {},
      orderList: [],
      payTotalAccount: null,
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log(' this.buttonList_tabl', this.buttonList_table)
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'delivery') {
          this.isDelivery = true
        }
      })
      console.log(this.isDetailShow)
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'updateLogis') {
          this.isUPdate = true
        }
      })

      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'logisRecord') {
          this.isShowRcode = true
        }
      })

      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'save') {
          this.isShowSave = true
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'back') {
          this.isShowBack = true
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'editLogis') {
          this.isEditLogisShow = true
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'addLogis') {
          this.isUpateLogisShow = true
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'deleteLogis') {
          this.isDelLogisShow = true
        }
      })
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.orderId = this.$route.query.orderId;
      console.log('审核退款', this.id);
      this.getDetail(this.$route.query.id)
      this.getOrderDetail()
    } else {
      return this.$message.error('缺少售后单Id,参数缺失')
    }
    this.getAllCompany();
  },
  methods: {
    getOrderDetail() {
      OrderPurchaseGet({ id: this.orderId }).then(res => {
        console.log('orderDetail99999', res);
        if (res.data.success) {
          this.orderDetail = res.data.result || {}
          this.payTotalAccount = res.data.result.payTotalAccount || null
          console.log('orderDetail', res);

          this.orderList = res.data.result.orderPurchases || []
          this.orderList.forEach(item => {
            item.supllierId = null
            item.supllierName = null
          })
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    cancelChoose() {
      // this.currentWarehouseData = {
      //   warehouseName: '',
      //   stock: '',
      //   isAccord: '',
      // };
      this.chooseDialog = false;

      // this.isShowChooseData = false;
    },
    confirmChoose() {
      // this.currentWarehouseData = {
      //   warehouseName:'',
      //   stock:'',
      //   isAccord:'',
      // };
      this.chooseDialog = false;
    },
    handleCurrentChange(val) {
      console.log('当前选择仓库', val);
      this.currentWarehouseData = {
        warehouseName: '',
        stock: '',
        isAccord: '',
        warehouseId: null,
      };
      this.currentWarehouseData = val;
      this.form.warehouseId = val.warehouseId;
      this.form.warehouseName = val.warehouseName;
      this.isShowChooseData = true;
    },
    back(row) {
      console.log('退回', row);
      this.$confirm("确认退回吗?", "提示", {
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(async () => {
          let res = await ConfirmReturn({ id: row.id });
          if (res.data.success) {
            this.$message.success(res.data.msg || '退回成功');
            await this.getDetail();
          } else {
            this.$message.error(res.data.error.message || '退回失败, 请重试')
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    deleteLogis(row) {
      console.log('物流删除 row', row);
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let res = await OrderAfterSaleLogisticDelete({ id: row.id });
        if (res.data.success) {
          console.log('del success')
          this.$message.success(res.data.msg || '删除成功');
          await this.getLogisRecord();
        } else {
          this.$message.error(res.data.error.message || '删除失败, 请重试')
        }
      }).catch(() => {
      });
    },
    editingLogis(row) {
      this.editLogis.logisticsCompanyId = row.logisticsCompanyId;
      this.editLogis.logisticsCompanyName = row.logisticsCompanyName;
      this.editLogis.logisticsNo = row.logisticsNo;
      this.editLogis.logisticQuantity = row.logisticQuantity;
      this.editLogis.logisticsCompanyId = row.logisticsCompanyId;
      this.editLoggisDialog = true;
    },
    async editLogisConfirm() {

      let res = await OrderAfterSaleLogisticUpdate(this.editLogis);
      if (res.data.success) {
        this.editLoggisDialog = false;
        this.addLogis = {
          logisticsCompanyId: null,
          logisticsCompanyName: '',
          logisticsNo: '',
          logisticQuantity: null,
        };
        this.$message.success(res.data.msg || '新增成功')
      }
    },
    editLogisCancel() {
      this.editLoggisDialog = false;
      this.editLogis = {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsNo: '',
        logisticQuantity: null,
      };
    },
    async createLogisConfirm() {
      let res = await OrderAfterSaleLogisticCreate(this.addLogis);
      if (res.data.success) {
        this.createLoggisDialog = false;
        this.addLogis = {
          logisticsCompanyId: null,
          logisticsCompanyName: '',
          logisticsNo: '',
          logisticQuantity: null,
        };
        await this.getLogisRecord();
        this.$message.success('新增成功')
      } else {
        this.$message.error(res.data.error.message || '新增失败, 请重试')

      }

    },
    async updateLogisConfirm() {
      this.updateLoggisDialog = false; return;
      let res = await OrderAfterSaleLogisticCreate(this.addLogis);
      if (res.data.success) {
        this.updateLoggisDialog = false;
        this.addLogis = {
          logisticsCompanyId: null,
          logisticsCompanyName: '',
          logisticsNo: '',
          logisticQuantity: null,
        };
        this.$message.success('新增成功')
      } else {
        this.$message.error(res.data.error.message || '新增失败, 请重试')
      }
    },
    updateLogisCancel() {
      this.updateLoggisDialog = false;
      this.updateLogis = {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsNo: '',
        logisticQuantity: null,
      }
    },
    createLogisCancel() {
      this.createLoggisDialog = false;
      this.addLogis = {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsNo: '',
        logisticQuantity: null,
      }
    },
    createLogis(row) {
      console.log('新增物流 row', row);
      this.addLogis.orderAfterSaleWarehouseId = row.id;
      this.createLoggisDialog = true;

    },
    showShow() {
      console.log('show')
    },

    logisRecord(item) {
      console.log('物流记录');
      this.getLogisRecord1(item);
      this.showRecordDialog = true;
    },
    logisRecord1(item) {
      console.log('物流记录', item);
      this.getLogisRecord1(item);
      this.showRecordDialog = true;
    },
    async getLogisRecord1(item) {
      console.log('舒心')
      let res = await OrderAfterSaleLogisticGetAll({ OrderAfterSaleDetailId: item.id });
      console.log('舒心', res);
      if (res.data.success) {
        // this.logisData = res.data.result.items;
        // this.logisData = res.data.result.items || [];
        this.recordData = res.data.result.items || [];
      } else {
        this.$message.error(res.data.error.message || '获取物流信息失败, 请重试')
      }
    },
    async getLogisRecord() {
      console.log('舒心')
      let res = await OrderAfterSaleWarehouseGetAll({ OrderAfterSaleDetailId: this.currentOrderAfterSaleDetailId });
      if (res.data.success) {
        // this.logisData = res.data.result.items;
        this.updateLogisData = res.data.result.items || [];
      } else {
        this.$message.error(res.data.error.message || '获取物流信息失败, 请重试')
      }
    },
    async updateLogistics(item) {
      console.log('更新物流', item);
      this.currentOrderAfterSaleDetailId = item.id; //新增 删除  刷新列表用
      this.updateLoggisDialog = true;
      let res = await OrderAfterSaleWarehouseGetAll({ OrderAfterSaleDetailId: item.id });
      console.log('物流更新', res);
      if (res.data.success) {
        this.updateLogisData = res.data.result.items || [];
        console.log('updateLogisData', this.updateLogisData);
        this.updateLoggisDialog = true;
      } else {
        this.$message.error(res.data.error.message || '货物物流信息失败, 请重试')
      }

    },
    async delivery(item, index) {
      console.log('发货', item);
      // 仓库信息
      let res = await GetAllInventoryItems();
      console.log('仓库', res);
      if (res.data.success) {
        this.wareHouseData = res.data.result.items
      } else {
        return this.$message.error(res.data.msg || '获取失败, 请重试')
      }

      this.form.afterSaleQuantity = item.afterSaleQuantity;
      // this.form.currentShipmentQuantity = item.afterSaleQuantity;  // 临时增加 的
      this.form.orderAfterSaleDetailId = item.id;
      // 拼接发货信息
      let params = {};
      params.OrderAfterSaleId = item.id;
      params.skipCount = 0;
      params.maxResultCount = 10;

      let ress = await OrderAfterSaleWarehouseGetAll(params);
      console.log('数量 查询 ', ress);
      console.log()
      if (ress.data.success) {
        if (ress.data.items) {
          let total = 0;
          ress.data.items.forEach(item => {
            total += item.shipmentQuantity
          })
          this.form.shipmentQuantity = total;  // 已发货数量
          // 剩余发货数量
          this.form.remainQuantity = this.detailData.afterSaleQuantity - this.form.shipmentQuantity;
        } else {
          this.form.shipmentQuantity = 0  // 无数据默认为 0
          // 剩余发货数量
          this.form.remainQuantity = this.detailData.afterSaleQuantity - this.form.shipmentQuantity;
        }
        console.log('需发货数量', this.detailData.afterSaleQuantity)
        console.log('已发货数量', this.form.shipmentQuantity)
        console.log('剩余发货数量', this.form.remainQuantity)
      } else {
        this.$message.error(res.data.error.message || '获取已发货数量失败,请重试')
      }



      this.deliveryDialog = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    save() {
      this.$confirm("确认提交保存吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let params = {};
        params.id = this.detailData.id;
        params.remark = this.remark;
        params.orderAfterSaleId = this.detailData.id;
        console.log('savbe', params)
        let res = await OrderAfterSaleUpdate(params);
        console.log('---', res);
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
          await this.getDetail();
        } else {
          this.$message.error(res.data.error.message || '保存失败, 请重试');
        }
      }).catch(() => {
      });
    },
    async getDetail() {
      let res = await OrderAfterSaleGet({ id: this.id })
      console.log('res', res);
      if (res.data.success) {
        const { orderAfterSaleDetails } = res.data.result;
        console.log('详情 res', orderAfterSaleDetails, this.exchangeLogisInfo)
        this.exchangeLogisInfo = orderAfterSaleDetails && orderAfterSaleDetails.filter((item) => {
          return item.supllierName !== '';
        })
        console.log(' this.exchangeLogisInfo', this.exchangeLogisInfo);
        const { orderAfterSaleNo } = res.data.result;
        const { afterSaleAmount } = res.data.result;
        const { afterSaleQuantity } = res.data.result;
        const { orderId } = res.data.result;
        const { afterSaleRemark } = res.data.result;
        this.remark = afterSaleRemark;
        const { id } = res.data.result;
        this.form.orderAfterSaleId = id;
        // this.form.afterSaleQuantity = afterSaleQuantity;
        // this.form.orderId = orderId;
        // console.log('orderAfterSaleNo', orderAfterSaleNo);
        // orderAfterSaleDetails &&  orderAfterSaleDetails.forEach(item => {
        //   item.orderAfterSaleNo = orderAfterSaleNo
        //   item.afterSaleAmount = afterSaleAmount
        // })
        console.log('orderAfterSaleDetails', orderAfterSaleDetails);
        this.tableData = orderAfterSaleDetails || [];
        this.detailData = res.data.result || {};
        console.log(' this.detailData', this.detailData);

      } else {
        this.$message.error(res.data.error || '获取失败,请重试')
      }
    },
    // 获取已发货数量
    /*
    * id 售后单id
    * */
    async getQuantity() {
      let params = {};
      params.OrderAfterSaleId = this.detailData.id;
      params.skipCount = 0;
      params.maxResultCount = 10;

      let res = await OrderAfterSaleWarehouseGetAll(params);
      console.log('shuliang chaxun ', res);
      console.log()
      if (res.data.success) {
        if (res.data.items) {
          let total = 0;
          res.data.items.forEach(item => {
            total += item.shipmentQuantity
          })
          this.form.shipmentQuantity = total;  // 已发货数量
          // 剩余发货数量
          this.form.remainQuantity = this.detailData.afterSaleQuantity - this.form.shipmentQuantity;
        } else {
          this.form.shipmentQuantity = 0  // 无数据默认为 0
          // 剩余发货数量
          this.form.remainQuantity = this.detailData.afterSaleQuantity - this.form.shipmentQuantity;
        }
        console.log('需发货数量', this.detailData.afterSaleQuantity)
        console.log('已发货数量', this.form.shipmentQuantity)
        console.log('剩余发货数量', this.form.remainQuantity)
      } else {
        this.$message.error(res.data.error.message || '获取已发货数量失败,请重试')
      }
    },
    batchCreateCancel() {
      this.deliveryDialog = false;
      this.buttonLoading = false;
      this.form = {
        productSupplierName: '',
        logisticsNo: '',
        orderId: '',
        orderPurchaseId: '',
        logisticsCompanyId: '',
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        CurrentShipmentQuantity: null,
        shipmentQuantity: null,
        remainQuantity: null,
        productSupplierId: null,
        purchaseQuantity: '',
        purchaseTotal: '',
        purchasePrice: '',
        orderNo: '',
        warehouseId: null,
        warehouseName: '',

      }
      this.currentWarehouseData = {
        warehouseName: '',
        stock: '',
        isAccord: '',
      };
      this.isShowChooseData = false;
    },
    async batchCreate() {
      let params = {};
      params.orderAfterSaleId = this.form.orderAfterSaleId;
      params.orderAfterSaleDetailId = this.form.orderAfterSaleDetailId;
      params.currentShipmentQuantity = this.form.currentShipmentQuantity;
      params.remainQuantity = this.form.remainQuantity;
      params.shipmentQuantity = this.form.currentShipmentQuantity;
      params.afterSaleQuantity = this.form.afterSaleQuantity;
      params.warehouseId = this.form.warehouseId;
      params.warehouseName = this.form.warehouseName;

      console.log('提交采购参数', params);
      this.buttonLoading = true;
      let res = await OrderAfterSaleWarehouseCreate(params);
      if (res.data.success) {
        this.$message.success(res.data.msg || '发货成功');
        this.form = {
          orderAfterSaleId: '',
          orderAfterSaleDetailId: '',
          currentShipmentQuantity: null,
          remainQuantity: null,
          shipmentQuantity: null,
          afterSaleQuantity: null,
          warehouseId: null,
          warehouseName: '',
        };
        this.deliveryDialog = false;
        this.buttonLoading = false;
        this.currentWarehouseData = {
          warehouseName: '',
          stock: '',
          isAccord: '',
        }; //清空已选择仓库数据
        this.isShowChooseData = false; // 隐藏已选的仓库
        await this.getDetail();
      } else {
        this.$message.error(res.data.error.msg || '发货失败, 请重试')
      }
      console.log('发货', res);
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getAllCompany(queryString);
        cb(res);
      } else {
        let res = await this.getAllCompany();
        cb(res);
      }
    },
    handleSelect(item) {
      console.log('物流公司', item);
      this.addLogis.logisticsCompanyId = item.id;
      this.addLogis.logisticsCompanyName = item.value;
      // this.form.logisticsCompanyName = item.logisticsCompanyName;
      this.addLogis.logisticsCompanyCode = item.code;
    },
    getAllCompany(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.LogisticsCompanyName = key;
      }
      return new Promise((resolve, reject) => {
        LogisticsCompanyServiceGetAll(obj).then((res) => {
          console.log('物流公司list', res);
          if (res.data.success) {
            this.logisCompanyData = res.data.result.items
              .map((item) => {
                return {
                  value: item.fullName,
                  id: item.id,
                  code: item.expressHundredCode
                };
              });
            resolve(this.logisCompanyData);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
      console.log('this.logisCompanyData', this.logisCompanyData);
    },
    async getWarehouseInfos(val) {
      // console.log('发货仓库', val);
      // this.form.warehouseName = val.warehouseName;
      // this.form.warehouseId = val.warehouseId;
      // console.log('this.form', this.form);
      let params = {};
      params.orderId = this.detailData.orderId;
      params.quantity = this.detailData.afterSaleQuantity;
      console.log('发货仓库params', params);
      let res = await GetAllInventoryItemsWithOrder(params);
      if (res.data.success) {
        this.currentWarehouseData = {
          warehouseName: '',
          stock: '',
          isAccord: '',
        };
        this.chooseDialog = true;

        this.logisData = res.data.result;
      } else {
        this.$message.error(res.data.error.message || '获取仓库信息失败, 请重试')
      }
      console.log('cangku', res);

    },
    getWarehouseInfo(val) {
      console.log('发货仓库', val);
      this.form.warehouseName = val.warehouseName;
      this.form.warehouseId = val.warehouseId;
      console.log('this.form', this.form);
    },
  }
}
</script>

<style scoped>
.aftersale-detail {
  padding: 0 20px;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-size: 16px;
  font-weight: 700;
}

.mgb15 {
  margin-bottom: 15px;
}

.mgr40 {
  margin-right: 40px;
}

.total-box {
  margin-top: 15px;
  text-align: right;
}

.btn-box {
  /* text-align: center; */
  margin-top: 20px;
}
</style>
